module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteCustomViewDialog.events.successfulDeletion":"Successfully deleted the custom view \u0027{customViewName}\u0027","deleteCustomViewDialog.title":"Delete Custom View","deleteCustomViewDialog.subtitle":"Please enter the name of this custom view to delete it.","deleteCustomViewDialog.warningText":"Deleting this custom view will also delete all associated budgets if any."}}')
  delete Component.options._Ctor
}
